import { createStore } from 'vuex'
import main from '../store/module/main'
import share from '../store/module/share'

export default createStore({
  state: {
    token: null,
    progress: 0,
    upload_list: [],
    mode: 'network',
  },
  mutations: {
    setToken (state, token) {
      state.token = token
    },
    SetProgress (state, progress) {
      state.progress = progress
    },
    SetUploadList (state, upload_list) {
      state.upload_list = upload_list
    },
    SetMode (state, mode) {
      state.mode = mode
    }
  },
  actions: {},
  getters: {
    progress: state => state.progress,
    mode: state => state.mode,
    upload_list: state => state.upload_list,

    slideList: state => main.state.slideList
  },
  modules: {
    main,
    share
  }
})
